
// export const urlcode = 'http://192.168.40.49:1090/sjch'  //fqf

export const urlcode = "https://kffyapi.sjhlwyy.com" 
export default {urlcode}


// WEBPACK FOOTER //
// ./src/config.js